import TopNav from "@/components/TopNav";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <TopNav />
      <main className="flex-1">{children}</main>
      <footer className="border-t border-[var(--ml-border)] py-6 mt-12">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[var(--ml-text-secondary)]">
          <div className="ml-mono uppercase tracking-widest">
            Modernize around IBM i — not away from it.
          </div>
          <div className="ml-mono">
            Powered by Claude Sonnet 4.5
          </div>
        </div>
      </footer>
    </div>
  );
}
